export enum FieldOptionsType {
  WIDGETS = "WIDGETS",
  COLUMNS = "COLUMNS",
  CUSTOM = "CUSTOM",
}
